export default __webpack_public_path__ + "static/media/IMAGE_17.4a150ff2.png";